/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Belegfeld1Inputs */



/**

* @param {_Field_Belegfeld1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_belegfeld1 = /** @type {((inputs?: _Field_Belegfeld1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Belegfeld1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Belegfeld 1")
});